import React, { useState } from "react";
import Navbar from "../components/Navbar";

// ── Phishing Dedektifi — Çok Aşamalı Simülasyon ─────────────────────────────

const SCENARIOS = [
  {
    id: 0,
    from: "guvenlik@e-devlet-destek-hizmetleri.com",
    fromReal: "guvenlik@turkiye.gov.tr",
    subject: "Acil! e-Devlet Hesabınız Tehlikede",
    date: "Bugün, 09:14",
    avatar: "🏛️",
    senderLabel: "e-Devlet Güvenlik",
    body: [
      { type: "text", content: "Sayın Kullanıcı," },
      { type: "text", content: "Sistemlerimiz hesabınızla ilgili bilgilerin karanlık web'de sızdırıldığını tespit etti. " },
      {
        type: "highlight",
        clue: 0,
        content: "Hemen aşağıdaki bağlantıya tıklayın",
        hint: "Meşru kurumlar asla 'hemen tıkla' baskısı yapmaz — panik yaratmak phishing'in klasik taktiğidir!",
        label: "Aciliyet Baskısı",
        icon: "⏰",
      },
      { type: "text", content: " ve şifrenizi doğrulayın." },
      {
        type: "link",
        clue: 1,
        display: "https://e-devlet-guvenlik-dogrulama.net/giris",
        hint: "Resmi URL 'turkiye.gov.tr' ile bitmeli! 'e-devlet-guvenlik-dogrulama.net' tamamen sahte bir alan adıdır.",
        label: "Sahte Alan Adı",
        icon: "🌐",
      },
      {
        type: "warning-box",
        clue: 2,
        content: "⚠️ Telefonunuza gelen 6 haneli doğrulama kodunu bu sayfaya girin. 30 dakika içinde yapmazsanız hesabınız kapatılacaktır.",
        hint: "Gerçek kurumlar SMS kodlarını asla bir web sayfasına girmenizi istemez — bu, 2FA'yı bypass etmek için kullanılan 'real-time phishing' tekniğidir!",
        label: "2FA Kodu Çalma",
        icon: "🛡️",
      },
    ],
    clueCount: 3,
  },
  {
    id: 1,
    from: "destek@paypal-guvenlik-merkezi.com",
    fromReal: "service@paypal.com",
    subject: "PayPal Hesabınız Kısıtlandı — Hemen Doğrulayın",
    date: "Dün, 22:47",
    avatar: "💳",
    senderLabel: "PayPal Destek",
    body: [
      { type: "text", content: "Merhaba," },
      {
        type: "sender-badge",
        clue: 0,
        content: "destek@paypal-guvenlik-merkezi.com",
        hint: "PayPal'ın resmi adresi '@paypal.com' ile biter. 'paypal-guvenlik-merkezi.com' sahte bir domain — araya 'guvenlik-merkezi' ekleyerek güvenilir görünmeye çalışıyorlar.",
        label: "Sahte Gönderici",
        icon: "📧",
      },
      { type: "text", content: " adresinden bir uyarı aldınız.\n\nHesabınızda şüpheli aktivite tespit edildi. Hesabınızı doğrulamak için lütfen " },
      {
        type: "highlight",
        clue: 1,
        content: "kart bilgilerinizi ve CVV kodunuzu",
        hint: "Hiçbir meşru finansal kuruluş e-posta yoluyla CVV kodu istemez! Bu, kart klonlama amacıyla kişisel veri toplamaktır.",
        label: "CVV / Kart Bilgisi İsteği",
        icon: "💰",
      },
      { type: "text", content: " formdaki alanları doldurun.\n\nYardım için: " },
      {
        type: "link",
        clue: 2,
        display: "https://paypal.guvenlik-dogrulama.info/verify",
        hint: "URL'nin yapısına dikkat edin: 'paypal.guvenlik-dogrulama.info' — paypal bir subdomain gibi görünse de asıl domain 'guvenlik-dogrulama.info'dur. Bu klasik bir subdomain phishing taktiğidir.",
        label: "Subdomain Aldatmacası",
        icon: "🔗",
      },
    ],
    clueCount: 3,
  },
];

export default function PhishingDedektifi() {
  const [scenarioIdx, setScenarioIdx] = useState(0);
  const [bulunanlar, setBulunanlar] = useState({});
  const [aktifModal, setAktifModal] = useState(null);
  const [tamamlandi, setTamamlandi] = useState({});
  const [gecisAnim, setGecisAnim] = useState(false);

  const scenario = SCENARIOS[scenarioIdx];
  const bulunanBu = bulunanlar[scenarioIdx] || [];
  const tumBulundu = bulunanBu.length >= scenario.clueCount;
  const toplamBulunan = Object.values(bulunanlar).flat().length;
  const toplamClue = SCENARIOS.reduce((s, sc) => s + sc.clueCount, 0);

  const ipucuTikla = (clueId) => {
    const clue = scenario.body.find(b => b.clue === clueId);
    if (!clue) return;
    setAktifModal({ ...clue, scenarioId: scenarioIdx });
    setBulunanlar(prev => {
      const mevcut = prev[scenarioIdx] || [];
      if (mevcut.includes(clueId)) return prev;
      return { ...prev, [scenarioIdx]: [...mevcut, clueId] };
    });
  };

  const siradakiSenaryoya = () => {
    setTamamlandi(prev => ({ ...prev, [scenarioIdx]: true }));
    setGecisAnim(true);
    setTimeout(() => {
      setScenarioIdx(1);
      setGecisAnim(false);
    }, 400);
  };

  const highlightStil = (clueId) => {
    const bulundu = bulunanBu.includes(clueId);
    return {
      display: "inline",
      background: bulundu ? "rgba(34,197,94,0.2)" : "rgba(251,191,36,0.1)",
      borderRadius: "4px",
      cursor: "pointer",
      border: bulundu ? "2px solid rgba(34,197,94,0.6)" : "2px dashed rgba(251,191,36,0.5)",
      padding: "1px 5px",
      transition: "all 0.2s",
      color: bulundu ? "#86efac" : "inherit",
    };
  };

  const renderBody = (parts) => parts.map((part, i) => {
    switch (part.type) {
      case "text":
        return <span key={i} style={{ whiteSpace: "pre-wrap" }}>{part.content}</span>;

      case "highlight":
        return (
          <span key={i} style={highlightStil(part.clue)} onClick={() => ipucuTikla(part.clue)}>
            {part.content}
            {!bulunanBu.includes(part.clue) && <sup style={{ color:"#fbbf24",fontSize:"0.65rem",marginLeft:"2px" }}>❓</sup>}
          </span>
        );

      case "sender-badge":
        return (
          <span key={i} style={{ ...highlightStil(part.clue), fontFamily:"monospace",fontSize:"0.88rem" }} onClick={() => ipucuTikla(part.clue)}>
            {part.content}
            {!bulunanBu.includes(part.clue) && <sup style={{ color:"#fbbf24",fontSize:"0.65rem",marginLeft:"2px" }}>❓</sup>}
          </span>
        );

      case "link":
        return (
          <span key={i} style={{ ...highlightStil(part.clue), color: bulunanBu.includes(part.clue) ? "#86efac" : "#60a5fa", textDecoration:"underline", fontFamily:"monospace", fontSize:"0.85rem" }} onClick={() => ipucuTikla(part.clue)}>
            {part.display}
            {!bulunanBu.includes(part.clue) && <sup style={{ color:"#fbbf24",fontSize:"0.65rem",marginLeft:"2px" }}>❓</sup>}
          </span>
        );

      case "warning-box":
        return (
          <div key={i} style={{ background:"rgba(239,68,68,0.07)",border:`2px ${bulunanBu.includes(part.clue)?"solid rgba(34,197,94,0.5)":"dashed rgba(251,191,36,0.35)"}`,borderRadius:"10px",padding:"0.9rem",marginTop:"1rem",cursor:"pointer",transition:"all 0.2s" }} onClick={() => ipucuTikla(part.clue)}>
            <span style={{ color:bulunanBu.includes(part.clue)?"#86efac":"#fca5a5",fontSize:"0.9rem",lineHeight:"1.6" }}>
              {part.content}
              {!bulunanBu.includes(part.clue) && <sup style={{ color:"#fbbf24",fontSize:"0.65rem",marginLeft:"4px" }}>❓</sup>}
            </span>
          </div>
        );

      default:
        return null;
    }
  });

  return (
    <div style={{ minHeight:"100vh",background:"#0c1222",fontFamily:"'Sora',sans-serif",color:"#fff" }}>
      <Navbar />
      <style>{`
        @keyframes popIn{from{opacity:0;transform:scale(0.88)}to{opacity:1;transform:scale(1)}}
        @keyframes fadeIn{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:translateY(0)}}
        @keyframes slideOut{to{opacity:0;transform:translateX(-30px)}}
        @keyframes scanline{0%{top:-10%}100%{top:110%}}
        .phish-hover:hover{filter:brightness(1.1);}
      `}</style>

      <div style={{ maxWidth:"700px",margin:"0 auto",padding:"2rem" }}>

        {/* Üst başlık */}
        <div style={{ textAlign:"center",marginBottom:"1.75rem" }}>
          <div style={{ fontSize:"2.5rem",marginBottom:"0.4rem" }}>🎣</div>
          <h1 style={{ margin:0,fontSize:"1.9rem",fontWeight:"800",background:"linear-gradient(90deg,#f97316,#fbbf24)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent" }}>
            Phishing Dedektifi
          </h1>
          <p style={{ color:"#64748b",marginTop:"0.3rem",fontSize:"0.88rem" }}>Sahte e-postaları tespit etmeyi öğren — sarı işaretli ipuçlarını bul!</p>
        </div>

        {/* Skor & ilerleme */}
        <div style={{ display:"flex",alignItems:"center",justifyContent:"space-between",background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:"14px",padding:"0.75rem 1.25rem",marginBottom:"1.5rem" }}>
          <div style={{ display:"flex",alignItems:"center",gap:"0.6rem" }}>
            <span style={{ fontSize:"1.1rem" }}>🔍</span>
            <span style={{ fontWeight:"600",fontSize:"0.9rem" }}>Dedektif Skoru:</span>
            <span style={{ color:"#fbbf24",fontWeight:"800",fontSize:"1.2rem" }}>{toplamBulunan} / {toplamClue}</span>
          </div>
          <div style={{ display:"flex",gap:"0.75rem",alignItems:"center" }}>
            {SCENARIOS.map((sc, i) => (
              <div key={sc.id} style={{ display:"flex",gap:"0.3rem",alignItems:"center" }}>
                <span style={{ fontSize:"0.75rem",color:"#475569",fontWeight:"600" }}>#{i+1}</span>
                {Array.from({length:sc.clueCount}).map((_,j) => (
                  <div key={j} style={{ width:"10px",height:"10px",borderRadius:"50%",background:(bulunanlar[i]||[]).length>j?"#22c55e":"#1e293b",transition:"background .3s" }} />
                ))}
              </div>
            ))}
          </div>
        </div>

        {/* Senaryo seçici */}
        <div style={{ display:"flex",gap:"0.75rem",marginBottom:"1.5rem" }}>
          {SCENARIOS.map((sc, i) => (
            <button key={sc.id} onClick={() => { setScenarioIdx(i); }}
              style={{ flex:1,padding:"0.6rem",borderRadius:"10px",border:`1.5px solid ${i===scenarioIdx?"#f97316":"rgba(255,255,255,0.1)"}`,background:i===scenarioIdx?"rgba(249,115,22,0.1)":"rgba(255,255,255,0.03)",color:i===scenarioIdx?"#fbbf24":"#64748b",fontSize:"0.8rem",fontWeight:"600",cursor:"pointer",transition:"all .2s",display:"flex",alignItems:"center",gap:"0.4rem",justifyContent:"center" }}>
              <span>{sc.avatar}</span>
              <span>{i===0?"e-Devlet":"PayPal"}</span>
              {tamamlandi[i] && <span style={{ color:"#22c55e" }}>✓</span>}
            </button>
          ))}
        </div>

        {/* E-posta kartı */}
        <div style={{ background:"#111827",border:"1px solid #1f2937",borderRadius:"18px",overflow:"hidden",boxShadow:"0 20px 50px rgba(0,0,0,0.6)",animation:gecisAnim?"slideOut 0.35s ease forwards":"fadeIn 0.4s ease" }}>

          {/* E-posta istemci başlığı */}
          <div style={{ background:"#0d1117",borderBottom:"1px solid #1f2937",padding:"0.65rem 1rem",display:"flex",gap:"0.5rem" }}>
            <div style={{ width:"12px",height:"12px",borderRadius:"50%",background:"#ff5f57" }} />
            <div style={{ width:"12px",height:"12px",borderRadius:"50%",background:"#febc2e" }} />
            <div style={{ width:"12px",height:"12px",borderRadius:"50%",background:"#28c840" }} />
            <div style={{ flex:1,background:"rgba(255,255,255,0.05)",borderRadius:"6px",height:"20px",margin:"0 0.5rem",display:"flex",alignItems:"center",padding:"0 0.6rem" }}>
              <span style={{ color:"#ef4444",fontSize:"0.7rem",fontFamily:"monospace" }}>🔴 DOĞRULANMAMIŞ GÖNDERICI</span>
            </div>
          </div>

          {/* Başlık satırı */}
          <div style={{ background:"#161d2e",padding:"1rem 1.5rem",borderBottom:"1px solid #1f2937",display:"flex",gap:"1rem",alignItems:"flex-start" }}>
            <div style={{ width:"44px",height:"44px",borderRadius:"50%",background:"linear-gradient(135deg,#1e3a5f,#2d4b73)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"1.4rem",flexShrink:0 }}>
              {scenario.avatar}
            </div>
            <div style={{ flex:1 }}>
              <div style={{ display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:"0.4rem" }}>
                <div>
                  <span style={{ color:"#e2e8f0",fontWeight:"700",fontSize:"0.95rem" }}>{scenario.senderLabel}</span>
                  <span style={{ color:"#ef4444",fontSize:"0.78rem",fontFamily:"monospace",marginLeft:"0.5rem",background:"rgba(239,68,68,0.12)",padding:"1px 6px",borderRadius:"4px" }}>
                    {scenario.from}
                  </span>
                </div>
                <span style={{ color:"#475569",fontSize:"0.78rem" }}>{scenario.date}</span>
              </div>
              <div style={{ color:"#fff",fontWeight:"700",fontSize:"1rem",marginTop:"0.3rem" }}>{scenario.subject}</div>
              <div style={{ color:"#475569",fontSize:"0.78rem",marginTop:"0.15rem" }}>
                Gerçek adres olmalıydı: <span style={{ color:"#86efac",fontFamily:"monospace" }}>{scenario.fromReal}</span>
              </div>
            </div>
          </div>

          {/* Gövde */}
          <div style={{ padding:"1.5rem",fontSize:"0.92rem",lineHeight:"1.8",color:"#cbd5e1" }}>
            {renderBody(scenario.body)}
          </div>

          {/* Bulunan ipuçları özeti */}
          {bulunanBu.length > 0 && (
            <div style={{ margin:"0 1.5rem 1.5rem",background:"rgba(34,197,94,0.06)",border:"1px solid rgba(34,197,94,0.2)",borderRadius:"12px",padding:"0.85rem 1rem" }}>
              <div style={{ color:"#86efac",fontSize:"0.78rem",fontWeight:"700",marginBottom:"0.5rem",textTransform:"uppercase",letterSpacing:"0.06em" }}>✅ Tespit Edilen Tehditler</div>
              <div style={{ display:"flex",flexWrap:"wrap",gap:"0.4rem" }}>
                {bulunanBu.map(clueId => {
                  const b = scenario.body.find(p => p.clue === clueId);
                  return b ? (
                    <span key={clueId} style={{ background:"rgba(34,197,94,0.15)",border:"1px solid rgba(34,197,94,0.3)",borderRadius:"999px",padding:"0.2rem 0.65rem",fontSize:"0.78rem",color:"#86efac",display:"flex",alignItems:"center",gap:"0.3rem" }}>
                      {b.icon} {b.label}
                    </span>
                  ) : null;
                })}
              </div>
            </div>
          )}

          {/* Tamamlandı aksiyonları */}
          {tumBulundu && (
            <div style={{ margin:"0 1.5rem 1.5rem",background:"linear-gradient(135deg,rgba(34,197,94,0.12),rgba(16,185,129,0.08))",border:"2px solid rgba(34,197,94,0.35)",borderRadius:"14px",padding:"1.25rem",textAlign:"center",animation:"fadeIn 0.5s ease" }}>
              <div style={{ fontSize:"2rem",marginBottom:"0.4rem" }}>🏅</div>
              <div style={{ color:"#86efac",fontWeight:"700",fontSize:"1.05rem",marginBottom:"0.4rem" }}>Bu senaryoyu tamamladın!</div>
              {scenarioIdx < SCENARIOS.length - 1 ? (
                <button onClick={siradakiSenaryoya} style={{ background:"linear-gradient(135deg,#f97316,#fbbf24)",border:"none",borderRadius:"10px",padding:"0.65rem 1.75rem",color:"#0f172a",fontWeight:"700",fontSize:"0.9rem",cursor:"pointer",marginTop:"0.5rem" }}>
                  Sonraki Senaryo →
                </button>
              ) : (
                <div style={{ color:"#94a3b8",fontSize:"0.88rem",marginTop:"0.5rem" }}>🎉 Tüm senaryoları tamamladın! Gerçek bir Phishing Dedektifisin!</div>
              )}
            </div>
          )}
        </div>

        {/* Tüm senaryo tamamlandı */}
        {Object.keys(tamamlandi).length === SCENARIOS.length && (
          <div style={{ marginTop:"1.5rem",background:"linear-gradient(135deg,rgba(30,27,75,0.9),rgba(15,23,42,0.95))",border:"2px solid rgba(251,191,36,0.4)",borderRadius:"20px",padding:"2rem",textAlign:"center",animation:"fadeIn 0.6s ease" }}>
            <span style={{ fontSize:"3rem",display:"block",marginBottom:"0.5rem" }}>🏆</span>
            <div style={{ color:"#fbbf24",fontSize:"1.4rem",fontWeight:"800",marginBottom:"0.5rem" }}>Mükemmel Dedektif!</div>
            <p style={{ color:"#94a3b8",margin:0,lineHeight:"1.6" }}>
              {toplamClue} ipucunu tespit ettin. Artık phishing saldırılarına karşı bilinçlisin!<br/>
              <strong style={{ color:"#fbbf24" }}>Altın kural:</strong> Şüpheli e-postalardaki linklere asla tıklama, her zaman URL'yi kontrol et.
            </p>
          </div>
        )}
      </div>

      {/* Modal */}
      {aktifModal && (
        <div style={{ position:"fixed",inset:0,background:"rgba(0,0,0,0.8)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200,padding:"1rem" }} onClick={() => setAktifModal(null)}>
          <div style={{ background:"linear-gradient(135deg,#0f172a,#1e293b)",border:"2px solid #22c55e",borderRadius:"22px",padding:"2.25rem",maxWidth:"440px",width:"100%",textAlign:"center",boxShadow:"0 0 60px rgba(34,197,94,0.25)",animation:"popIn 0.3s ease" }} onClick={e => e.stopPropagation()}>
            <div style={{ width:"64px",height:"64px",borderRadius:"50%",background:"rgba(34,197,94,0.15)",border:"2px solid rgba(34,197,94,0.4)",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 1rem",fontSize:"1.8rem" }}>
              {aktifModal.icon}
            </div>
            <div style={{ color:"#22c55e",fontSize:"1.15rem",fontWeight:"800",marginBottom:"0.6rem" }}>{aktifModal.label}</div>
            <p style={{ color:"#cbd5e1",fontSize:"0.93rem",lineHeight:"1.7",marginBottom:"1.5rem" }}>{aktifModal.hint}</p>
            <button style={{ background:"linear-gradient(135deg,#22c55e,#16a34a)",color:"#0f172a",border:"none",borderRadius:"12px",padding:"0.75rem 2rem",fontSize:"0.95rem",fontWeight:"700",cursor:"pointer" }} onClick={() => setAktifModal(null)}>
              Anladım! ✓
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
